import * as React from 'react';
import { cn } from '@/lib/utils';

type StatusBadgeTone = 'neutral' | 'warning' | 'info' | 'success' | 'danger' | 'accent';

interface StatusBadgeProps extends React.HTMLAttributes<HTMLDivElement> {
  tone?: StatusBadgeTone;
}

const toneClasses: Record<StatusBadgeTone, string> = {
  neutral: 'outline-gray-400 text-gray-600',
  warning: 'outline-yellow-400 text-yellow-500',
  info: 'outline-blue-400 text-blue-500',
  success: 'outline-green-500 text-green-500',
  danger: 'outline-rose-500 text-rose-500',
  accent: 'outline-teal-400 text-teal-400',
};

export function StatusBadge({ tone = 'neutral', className, ...props }: StatusBadgeProps) {
  return (
    <div
      className={cn(
        'inline-flex items-center justify-center gap-1.5 rounded-md px-2 py-[5px] text-xs font-medium tracking-tight outline outline-1 outline-offset-[-1px]',
        toneClasses[tone],
        className
      )}
      {...props}
    />
  );
}
